import { render, staticRenderFns } from "./MailForwardingIntegration.vue?vue&type=template&id=50e3ef38"
import script from "./MailForwardingIntegration.vue?vue&type=script&lang=js"
export * from "./MailForwardingIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports